import Promise from 'bluebird';

import { useAction } from './hooks/use-data-actions';

import { getCCJsDataObj } from './ccui-util';
import type {
  CCDataServerContext,
  CCJsDataRepositories,
} from './types';

class OfflinePiInstructionsActions {
  jsDataCcRest: CCJsDataRepositories;

  constructor({
    CurrentCustomer,
    CurrentUser
  }: CCDataServerContext) {
    const cid = CurrentCustomer && CurrentCustomer.Id;
    const uid = CurrentUser && CurrentUser.Id;

    this.jsDataCcRest = getCCJsDataObj(cid, uid);
  }

  fetchAll = (currencyCode: string, countryCode: string) =>
    Promise.resolve(this.jsDataCcRest.OfflinePaymentInstructions.findAll(
      { currencyCode, countryCode },
      { bypassCache: true }
    ));
}

export const useOfflinePaymentInstructionPaymentAction =
(serverContext: CCDataServerContext) =>
  useAction(OfflinePiInstructionsActions, serverContext);
